import DefaultLayout from '@/views/DefaultLayout.vue';
import { RouteConfig } from 'vue-router';
import AppListIframe from '@/views/contents/app/basic/AppListIframe.vue';
import AppAllIframe from '@/views/contents/app/basic/AppAllIframe.vue';

export default (): RouteConfig => {
  return {
    path: '/app',
    name: 'App',
    component: DefaultLayout,
    children: [
      {
        path: 'basic/list',
        name: 'AppList',
        component: AppListIframe,
      },
      {
        path: 'basic/all',
        name: 'AppAll',
        component: AppAllIframe,
      },
    ],
  };
};
